export default __webpack_public_path__ + "static/media/logo_itesa.86c26619.svg";